import { FeatureTags } from '@spazious/dollhouse-types';

export const PLANNER_FEATURES_MODE_EDIT: FeatureTags[] = [
  'decorations',
  'furnitures',
  'farrangements',
  'fensembles',
  'records',
  'share',
  'inspector',
  'templates',
  'history',
  'graphs.setup:editable',
  'graphs.setup.node',
  'graphs.setup.node:editable',
  'graphs.setup.name',
  'graphs.setup.node.props',
  'graphs.setup.node.props:editable',
  'graphs.setup.node.attrs',
  'graphs.setup.node.attrs:editable',
  'graphs.setup.node.meta',
  'graphs.setup.node.meta:editable',
  'graphs.setup.node.decoration',
  'graphs.setup.node.decoration:editable',
  'graphs.setup.node.annotation',
  'graphs.setup.node.annotation:editable',
  'graphs.setup.node.camerapath',
  'tool.duplicate',
  'tool.move',
  'tool.annotation',
  'tool.ruler',
  'tool.select',
  'tool.numbering',
];

export const PLANNER_MOBILE_FEATURES_MODE_EDIT: FeatureTags[] = [
  'templates',
  'graphs.setup.node',
  'graphs.setup.name',
  'graphs.setup.node.props',
  'graphs.setup.node.attrs',
  'graphs.setup.node.meta',
  'graphs.setup.node.decoration',
  'graphs.setup.node.camerapath',
];

export const PLANNER_FEATURES_MODE_READ_ONLY: FeatureTags[] = [
  'graphs.setup',
  'graphs.setup.name',
  'graphs.setup.node',
  'graphs.setup.node.measurement',
  'graphs.setup.node.props',
  'graphs.setup.node.meta',
  'graphs.setup.node.decoration',
  'graphs.setup.node.annotation',
  'graphs.setup.node.camerapath',
];

export const PLANNER_MOBILE_FEATURES_MODE_READ_ONLY: FeatureTags[] = [
  'graphs.setup',
  'graphs.setup.name',
  'graphs.setup.node',
  'graphs.setup.node.measurement',
  'graphs.setup.node.props',
  'graphs.setup.node.meta',
  'graphs.setup.node.decoration',
  'graphs.setup.node.annotation',
  'graphs.setup.node.camerapath',
];

// prettier-ignore
export const PLANNER_FEATURES_MODE_RTS_GUEST: FeatureTags[] = [
  'real-time-sharing',
  'real-time-sharing.guest',
  ...PLANNER_FEATURES_MODE_READ_ONLY
];
// prettier-ignore
export const PLANNER_MOBILE_FEATURES_MODE_RTS_GUEST: FeatureTags[] = [
  'real-time-sharing',
  'real-time-sharing.guest',
  ...PLANNER_MOBILE_FEATURES_MODE_READ_ONLY,
];

export const PLANNER_FEATURES_MODE_CREATION: FeatureTags[] = [
  'decorations',
  'furnitures',
  'farrangements',
  'fensembles',
  'records',
  'share',
  'templates',
  'inspector',
  'history',
  'graphs.setup:editable',
  'graphs.setup.name',
  'graphs.setup.node',
  'graphs.setup.node:editable',
  'graphs.setup.node.props',
  'graphs.setup.node.props:editable',
  'graphs.setup.node.attrs',
  'graphs.setup.node.attrs:editable',
  'graphs.setup.node.meta',
  'graphs.setup.node.meta:editable',
  'graphs.setup.node.decoration',
  'graphs.setup.node.decoration:editable',
  'graphs.setup.node.annotation',
  'graphs.setup.node.annotation:editable',
  'graphs.setup.node.camerapath',
  'tool.duplicate',
  'tool.move',
  'tool.annotation',
  'tool.ruler',
  'tool.select',
  'tool.numbering',
];

export const PLANNER_MOBILE_FEATURES_MODE_CREATION: FeatureTags[] = [
  'templates',
  'graphs.setup.node',
  'graphs.setup.name',
  'graphs.setup.node.props',
  'graphs.setup.node.attrs',
  'graphs.setup.node.meta',
  'graphs.setup.node.decoration',
  'graphs.setup.node.camerapath',
];
